import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MotionPhotosPausedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"motion_photos_paused"}/>
}
